<!-- 车位使用情况数据(Echart) -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "startDate": "20190917000000",
                "endDate": "20190917235959",
                "minuteInterval": 240
            },
            responseCode: {
                    "data": {
                        "points": [
                            [
                                "1",
                                "1",
                                "0.8816"
                            ],
                            [
                                "2",
                                "1",
                                "0.8816"
                            ],
                            [
                                "3",
                                "1",
                                "0.8816"
                            ],
                            [
                                "4",
                                "1",
                                "0.8816"
                            ],
                            [
                                "5",
                                "1",
                                "0.8816"
                            ],
                            [
                                "6",
                                "1",
                                "0.8816"
                            ]
                        ],
                        "x": [
                            "04:00",
                            "08:00",
                            "12:00",
                            "16:00",
                            "20:00",
                            "00:00"
                        ],
                        "y": [
                            "1"
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车位使用情况数据，用于绘制echart笛卡尔坐标系上的热力图",
                t_url: this.commonUrls.test+"parkingPlaceUsedForEchart",
                p_url: this.commonUrls.prod+"parkingPlaceUsedForEchart",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'startDate', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        { info1: 'minuteInterval', info2: '是', info3: 'Integer', info4: '分钟间隔(支持10或240)' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'x', info2: '是', info3: 'String[]', info4: 'x轴元坐标' },
                        { info1: 'y', info2: '是', info3: 'String[]', info4: 'y轴元坐标' },
                        { info1: 'points', info2: '是', info3: 'String[][]', info4: '绘图平面点数组，点排列沿x、y轴正方向顺序分布。具体见echart样例：https://www.echartsjs.com/examples/zh/editor.html?c=heatmap-cartesian' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/parkingPlaceUsedForEchart.vue